import { Injectable } from '@angular/core';
import { loggerFor } from '@app/utils/logger';
import { Observable, Subject } from 'rxjs';
import { filter, share } from 'rxjs/operators';
import { ApplicationEvent, ApplicationEventFactory } from './application-event-factory';
import { EventType } from './events';

@Injectable({
  providedIn: 'root',
})
export class ApplicationEventService {
  private _subject = new Subject<ApplicationEvent<any, any>>();
  private _event$ = this._subject.asObservable().pipe(share());

  private log = loggerFor('ApplicationEventService');

  get event$(): Observable<ApplicationEvent<any, any>> {
    return this._event$;
  }

  emit<T extends EventType, P>(event: ApplicationEvent<T, P>): void {
    this.log.info(`Emit application event "${event.id}"`, event);

    this._subject.next(event);
  }

  on$<T extends EventType, Payload>(
    factory: ApplicationEventFactory<T, Payload>
  ): Observable<ApplicationEvent<T, Payload>> {
    return this.event$.pipe(filter(factory.is));
  }
}
